import SvgIcon from '@mui/material/SvgIcon';

const PlaybackIcon = ({ color = 'white' }) => {
    return (
        <SvgIcon>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M4.42969 4.42969L3.10156 3.10156C2.51172 2.51172 1.5 2.92969 1.5 3.76172V8.0625C1.5 8.58203 1.91797 9 2.4375 9H6.73828C7.57422 9 7.99219 7.98828 7.40234 7.39844L6.19922 6.19531C7.55469 4.83984 9.42969 4 11.5 4C15.6406 4 19 7.35938 19 11.5C19 15.6406 15.6406 19 11.5 19C9.90625 19 8.42969 18.5039 7.21484 17.6562C6.64844 17.2617 5.87109 17.3984 5.47266 17.9648C5.07422 18.5312 5.21484 19.3086 5.78125 19.707C7.40625 20.8359 9.37891 21.5 11.5 21.5C17.0234 21.5 21.5 17.0234 21.5 11.5C21.5 5.97656 17.0234 1.5 11.5 1.5C8.73828 1.5 6.23828 2.62109 4.42969 4.42969Z"
                    fill={color}
                />
                <path
                    d="M10.3307 8.11026C10.0609 7.96809 9.72188 7.96341 9.44661 8.0962C9.17135 8.22899 9 8.47894 9 8.75077V14.2498C9 14.5216 9.17135 14.7716 9.44661 14.9044C9.72188 15.0372 10.0609 15.0309 10.3307 14.8903L15.5807 12.1408C15.8414 12.0049 16 11.7627 16 11.5003C16 11.2378 15.8414 10.9972 15.5807 10.8598L10.3307 8.11026Z"
                    fill={color}
                />
            </svg>
        </SvgIcon>
    );
};

export default PlaybackIcon;
